import React from 'react';
import { HiStar, HiOutlineUserGroup } from 'react-icons/hi2';
import {
  ConnectionIndicator,
  SectionHeader,
  SectionHeaderSideSpacer,
  ChatHeaderName,
  ChatHeaderStatus,
} from '../../styles/UserWorkspacePageStyles';
import { techColors } from '../../styles/TechRetroEffects';
import { useT } from '../../LocaleContext';

const centerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  justifyContent: 'center',
  flex: 1,
  minWidth: 0,
  cursor: 'default',
};

const ChatHeader = ({
  chat,
  chatTrustPolicies,
  onOpenMembers,
  embedded = false,
}) => {
  const t = useT();

  if (!chat) {
    return null;
  }

  const headerProps = embedded ? { $static: true, $embedded: true } : { $static: true };
  const sideSpacer = embedded ? null : (size) => <SectionHeaderSideSpacer $size={size} aria-hidden="true" />;

  if (chat.peer_name === 'favorites') {
    return (
      <SectionHeader {...headerProps}>
        {!embedded && sideSpacer(24)}
        <div style={centerStyle}>
          <span
            style={{
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: techColors.darkBgTertiary,
              border: `1px solid ${techColors.borderSubtle}`,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <HiStar style={{ width: '14px', height: '14px', color: '#ffffff', fill: '#ffffff' }} />
          </span>
          <ChatHeaderName>{t('chat.favorites')}</ChatHeaderName>
        </div>
        {!embedded && sideSpacer(28)}
      </SectionHeader>
    );
  }

  if (chat.chat_type === 'group') {
    return (
      <SectionHeader {...headerProps}>
        {!embedded && sideSpacer(28)}
        <div
          style={{ ...centerStyle, cursor: onOpenMembers ? 'pointer' : 'default' }}
          onClick={onOpenMembers}
          title={onOpenMembers ? t('chat.groupInfo') : undefined}
        >
          <HiOutlineUserGroup style={{ color: techColors.neonCyan, fontSize: '1.1em', flexShrink: 0 }} />
          <ChatHeaderName>{chat.title || t('chat.group')}</ChatHeaderName>
          <ChatHeaderStatus $tone="muted">
            {t('chat.membersCount', { count: chat.member_count || 0 })}
          </ChatHeaderStatus>
        </div>
        {!embedded && sideSpacer(28)}
      </SectionHeader>
    );
  }

  const trustPolicy = chatTrustPolicies?.[chat.id];
  const shareStatus = trustPolicy?.shareStatus;
  const isOnline = chat.user_online === 'true';
  const isUnknown = !shareStatus;

  let statusText = t('common.offline');
  let tone = 'offline';
  if (isUnknown) {
    statusText = t('chat.statusHidden');
    tone = 'muted';
  } else if (isOnline) {
    statusText = t('common.online');
    tone = 'online';
  }

  return (
    <SectionHeader {...headerProps}>
      {!embedded && sideSpacer(24)}
      <div style={centerStyle}>
        <ChatHeaderName>{chat.peer_name}</ChatHeaderName>
        <ConnectionIndicator isConnected={isOnline} isUnknown={isUnknown} />
        <ChatHeaderStatus $tone={tone}>{statusText}</ChatHeaderStatus>
      </div>
      {!embedded && sideSpacer(28)}
    </SectionHeader>
  );
};

export default ChatHeader;
